import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';

import { ServerOverviewService } from './server-overview.service';

@Component({ selector: 'amp-server-process', templateUrl: './server-process.component.html', styleUrls: ['./server-process.component.scss'] })
export class ServerProcessComponent implements OnInit, OnDestroy {
  processes$: Observable<Array<any>>;

  constructor(private overviewService: ServerOverviewService, public translateService: TranslocoService) {
    this.processes$ = this.overviewService.serverProcess$;
  }

  ngOnInit(): void {
    this.overviewService.start();
  }

  ngOnDestroy(): void {
    this.overviewService.stop();
  }
}
